import { clearValue, getValue, refreshValue, storeValue } from '@infinitro/global/storage';
export const guestStorage = {
    getItem: async (key, realm) => {
        const prefixedKey = `${realm}_${key}`;
        const value = await getValue(prefixedKey);
        return value ? JSON.parse(value) : null;
    },
    setItem: async (key, value, realm, expires) => {
        const prefixedKey = `${realm}_${key}`;
        await storeValue(prefixedKey, JSON.stringify(value), expires);
    },
    removeItem: async (key, realm) => {
        const prefixedKey = `${realm}_${key}`;
        await clearValue(prefixedKey);
    },
    refreshItem: async (key, realm, expires) => {
        const prefixedKey = `${realm}_${key}`;
        const value = await refreshValue(prefixedKey, expires);
        return value ? JSON.parse(value) : null;
    },
    addGame: async (key, game, realm, expires) => {
        let games = (await guestStorage.getItem(key, realm)) || [];
        if (games.includes(game)) {
            games = games.filter((g) => g !== game);
        }
        else {
            games.push(game);
        }
        await guestStorage.setItem(key, games, realm, expires);
    }
};
export const playerStorage = {
    getItem: async (key, playerId) => {
        const prefixedKey = `${playerId}_${key}`;
        const value = await getValue(prefixedKey);
        return value ? JSON.parse(value) : null;
    },
    setItem: async (key, value, playerId, expires) => {
        const prefixedKey = `${playerId}_${key}`;
        await storeValue(prefixedKey, JSON.stringify(value), expires);
    },
    removeItem: async (key, playerId) => {
        const prefixedKey = `${playerId}_${key}`;
        await clearValue(prefixedKey);
    },
    refreshItem: async (key, playerId, expires) => {
        const prefixedKey = `${playerId}_${key}`;
        const value = await refreshValue(prefixedKey, expires);
        return value ? JSON.parse(value) : null;
    },
    addGame: async (key, game, playerId, expires) => {
        let games = (await playerStorage.getItem(key, playerId)) || [];
        if (games.includes(game)) {
            games = games.filter((g) => g !== game);
        }
        else {
            games.push(game);
        }
        await playerStorage.setItem(key, games, playerId, expires);
    }
};
